import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, verifyOtp as apiVerifyOtp, getMe } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ms_token');
    if (token) {
      getMe().then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem('ms_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // Step 1: check email exists → returns { requiresOtp, userId, message }
  const login = async (email) => {
    const res = await apiLogin(email);
    return res.data; // { requiresOtp: true, userId, message }
  };

  // Step 2: verify OTP → issues JWT, sets user in context
  const verifyOtp = async (userId, code) => {
    const res = await apiVerifyOtp(userId, code);
    localStorage.setItem('ms_token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('ms_token');
    setUser(null);
  };

  const refresh = async () => {
    try {
      const res = await getMe();
      setUser(res.data.user);
      return res.data.user;
    } catch { return null; }
  };

  const can = (perm) => user?.permissions?.includes(perm) || user?.permissions?.includes('view_all');

  return (
    <AuthContext.Provider value={{ user, login, verifyOtp, logout, refresh, can, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
